import React, { Component } from "react";
import NavLink from "./NavLink.jsx";
import LogoutLink from "./LogoutLink.jsx";
import { Link } from "react-router";
import _ from "lodash";
import { CircularProgress } from "material-ui";
import searchIcon from "../../assets/img/icon/search.png";
import InputField from "../InputField/InputField";
import PasswordField from "../InputField/PasswordField";
import notificationSrc from "../../assets/img/notification-bell.png";

const showNotificationsRoles = ["user", "admin", "superhost"];

class Navbar extends Component {
  state = {
    cookieClientAgreed: false,
    PWAnotification: false,
    input: "",
    showSearch: false,
  };

  changeSearchString = (e) => {
    const { value } = e.target;
    if (value === "")
      document.getElementsByTagName("body")[0].classList.remove("search");
    this.setState((prev) => ({ ...prev, input: value }));
    this.handleSearch(value);
  };

  setInputVal = (val) => {
    this.setState((prev) => ({ ...prev, input: val }));
  };

  handleSearch = _.debounce((value) => {
    if (value.length > 1) this.props.searchWebinarsTerms(value);
    else this.props.clearTerms();
  }, 350);

  componentDidMount() {
    const cookieAgreement = !!localStorage.getItem("cookieAgreement");
    if (cookieAgreement) {
      this.setState({
        cookieClientAgreed: true,
      });
    }
    const PWAnotification = !!localStorage.getItem("PWAnotification");
    if (PWAnotification) {
      this.setState({
        PWAnotification: true,
      });
    }
  }

  cookieAgree = (e) => {
    localStorage.setItem("cookieAgreement", "true");
    this.setState({
      cookieClientAgreed: true,
    });
  };

  updatePWAnotification = (e) => {
    localStorage.setItem("PWAnotification", "true");
    this.setState({
      PWAnotification: true,
    });
  };

  clean = () => {
    this.props.clearTerms();
    this.setState((prev) => ({ ...prev, input: "", showSearch: false }));
    document.getElementsByTagName("body")[0].classList.remove("search");
  };

  toggleSearchOn = () => {
    this.setState((prev) => ({ ...prev, showSearch: true }));
  };

  toggleSearchOff = () => {
    document.getElementsByTagName("body")[0].classList.remove("search");
    this.setState((prev) => ({ ...prev, showSearch: false }));
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.terms.length === 0)
      document.getElementsByTagName("body")[0].classList.remove("search");
    if (nextProps.terms.length > 0)
      document.getElementsByTagName("body")[0].classList.add("search");
    if (!nextProps.isSearching)
      document.getElementsByTagName("body")[0].classList.remove("search");
  }

  render() {
    const { cookieClientAgreed, PWAnotification } = this.state;
    const { changeSearchString } = this;

    const {
      links,
      logoutAction,
      user,
      toggleNavbar,
      pathname,
      handleChange,
      inputData,
      handleSubmitLogin,
      notificationCount,
    } = this.props;

    const showSearchForWebinars =
      user &&
      user.role === "user" &&
      (pathname === "/" || pathname === "/search" || pathname === "/webinars");
    const isAuthPage =
      ["/users/sign_in", "/users/sign_up", "/users/forgot_password"].indexOf(
        pathname
      ) > -1;
    const showLanding =
      ([
        "/",
        "/booking_webinar",
        "/terms_of_service",
        "/privacy_policy",
        "/faq",
        "/about_us",
        "/cookie_policy",
      ].indexOf(pathname) > -1 ||
        isAuthPage) &&
      !user.id;

    const showNotification =
      showNotificationsRoles.includes(user.role) &&
      (pathname.includes("groups") || pathname.includes("notifications"));

    return (
      <header
        className={`main_header ${!showLanding ? "noLandingMarginMain" : ""} ${
          showLanding ? "landing" : ""
        }`}
      >
        <div>
          <div className="logo">
            <Link to="/">
              <img src="/assets/img/Medcafe_logo.png" alt="logo" />
            </Link>
          </div>
          <div className="header_nav">
            <ul>
              {links.map(e => (
                <NavLink link={e.link} text={e.text} key={e.link} />
              ))}
              {logoutAction && (
                <LogoutLink
                  onClick={this.props.logoutAction}
                  user={user}
                  showNotifications={showNotification}
                  notificationsCount={notificationCount}
                />
              )}
              {showSearchForWebinars && (
                <InputSearch
                  push={this.props.push}
                  onChange={changeSearchString}
                  terms={this.props.terms}
                  isSearching={this.props.isSearching}
                  setInputVal={this.setInputVal}
                  input={this.state.input}
                  showSearch={this.state.showSearch}
                  toggleOn={this.toggleSearchOn}
                  toggleOff={this.toggleSearchOff}
                  clean={this.clean}
                />
              )}
            </ul>
          </div>
        </div>
        <div className={`landing noUnder800${!showLanding ? " hide" : ""}`}>
          {/* <div className='site--width landing'> */}
          <div className="buttons" style={{ flex: 1 }}>
            <Link to="/booking_webinar" className="button my">
              BOOK A MEETING
            </Link>
            <Link to="/users/sign_up" className="button my">
              SIGN UP
            </Link>
            <Link to="/faq" className="my">
              FAQs
            </Link>
            {showSearchForWebinars && (
              <InputSearch
                guest
                push={this.props.push}
                onChange={changeSearchString}
                terms={this.props.terms}
                isSearching={this.props.isSearching}
                setInputVal={this.setInputVal}
                input={this.state.input}
                showSearch={this.state.showSearch}
                toggleOn={this.toggleSearchOn}
                toggleOff={this.toggleSearchOff}
                clean={this.clean}
              />
            )}
          </div>
          <Link to="/">
            <img src="/assets/img/Medcafe_logo.png" alt="logo" />
          </Link>
          {!isAuthPage ? (
            <form
              onSubmit={handleSubmitLogin}
              className="auth"
              style={{ flex: 1 }}
            >
              <div
                className="auth"
                style={{ maxWidth: 360, marginLeft: "auto" }}
              >
                <InputField
                  size="small"
                  value={inputData.email}
                  field_name="email"
                  onChange={handleChange}
                  className="input"
                  label="Email"
                />
                <div className="flex">
                  <PasswordField
                    size="small"
                    value={inputData.password}
                    field_name="password"
                    onChange={handleChange}
                    className="input"
                    label="Password"
                  />
                  <input
                    type="submit"
                    disabled={inputData.isLoading}
                    className="button"
                    value="SIGN IN"
                  />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Link to="/users/forgot_password">Forgot password?</Link>
                  <Link to="/users/sign_in/admin" style={{ color: "gray" }}>
                    Admin
                  </Link>
                </div>
              </div>
            </form>
          ) : (
            <div style={{ flex: "1 1 0%" }} />
          )}
          {/* </div> */}
        </div>

        <div className="navigation">
          {showNotification && (
            <Link
              to={"/notifications"}
              style={{
                position: "relative",
                alignSelf: "center",
              }}
            >
              {!!notificationCount && (
                <div
                  style={{
                    position: "absolute",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: "red",
                    right: "7px",
                  }}
                />
              )}
              <img
                style={{ width: "35px", height: "35px" }}
                src={notificationSrc}
                alt="notification-bell"
              />
            </Link>
          )}
          <button id="sized" className="menu" onClick={toggleNavbar}>
            <span />
          </button>
        </div>

        {!cookieClientAgreed && (
          <div className="cookies-popup">
            <div className="cookies-wrapper">
              <p>
                We use cookies to give you the best experience possible on our
                website, including analytics and content personalisation. By
                continuing to browse this website, you agree to the use of
                cookies.
                <Link to="/cookie_policy">Find out more</Link>
              </p>
              <button className="enter_med" onClick={this.cookieAgree}>
                Accept and close
              </button>
            </div>
          </div>
        )}

        {/* {!PWAnotification && (
          <div className="cookies-popup">
            <div
              className="cookies-wrapper"
              style={{ justifyContent: "space-between" }}
            >
              <p>
                Our app now supports Progressive Web App features! Add it to
                your home screen for a better experience
              </p>
              <button
                className="enter_med"
                onClick={this.updatePWAnotification}
              >
                Close
              </button>
            </div>
          </div>
        )} */}
      </header>
    );
  }
}

const InputSearch = ({
  onChange,
  terms,
  isSearching,
  push,
  input,
  setInputVal,
  showSearch,
  toggleOn,
  toggleOff,
  clean,
  guest,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    push(`/search?q=${e.target[0].value}`);
    clean();
    console.log("i submitted");
  };

  const onClick = (item) => {
    push(`/search?q=${item}`);
    clean();
    // toggleOff()
  };

  const onBlur = _.memoize(() =>
    _.debounce(() => {
      toggleOff();
    }, 200)
  );

  const onFocus = (e) => {
    if (terms.length > 0 && e.target.value.length > 0)
      document.getElementsByTagName("body")[0].classList.add("search");
    toggleOn();
  };

  return (
    <form
      className={`searchInput${guest ? " guest" : ""}`}
      onSubmit={handleSubmit}
    >
      <input
        type="text"
        onChange={onChange}
        placeholder="Search..."
        value={input}
        onFocus={toggleOn}
        onBlur={onBlur}
      />
      <div className="searchIcon">
        <img src={searchIcon} alt="🔍" />
      </div>
      {!guest && <button type="submit">Search</button>}
      <div
        className={`searchList ${
          showSearch && input.length > 0 ? "active" : ""
        }`}
      >
        {isSearching && terms.length === 0 ? (
          <div>
            <CircularProgress color="inherit" />
          </div>
        ) : (
          terms.map((item, index) => (
            <a key={`search${guest}${index}`}>
              <div onClick={() => onClick(item)}>{item}</div>
            </a>
          ))
        )}
      </div>
    </form>
  );
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.jsx